import icon1 from "../../../assets/Cicon-1.svg";
import iconDesc from "../../../assets/Frame (2).svg";



export const SupportArray = [
    
    {
        title:"Introduction to hosting",
        icon: icon1,
        accordions: [
            {   iconDesc : iconDesc,
                query: "How can I optimize my blog for better visibility?",
                solution: "You can improve your blog's visibility by focusing on SEO, using relevant keywords, and promoting it on social media."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
        ]
     
        
    },
    {
        title:"Setting up a website",
        icon: icon1,
        accordions: [
            {iconDesc : iconDesc,
                query: "How can I optimize my blog for better visibility?",
                solution: "You can improve your blog's visibility by focusing on SEO, using relevant keywords, and promoting it on social media."
            },
            {iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
        ]
       
    },
    {
        title:"Security and privacy",
        icon: icon1,
        accordions: [
            {iconDesc : iconDesc,
                query: "How can I optimize my blog for better visibility?",
                solution: "You can improve your blog's visibility by focusing on SEO, using relevant keywords, and promoting it on social media."
            },
            {iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
            {   iconDesc : iconDesc,
                query: "What tools can help me with content creation?",
                solution: "Tools like Grammarly, Hemingway Editor, and Canva can assist you in creating high-quality content."
            },
        ]
    }
]